var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAverages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666992 0.666748V14.8334C0.666992 16.2141 1.78628 17.3334 3.16699 17.3334H17.3337V15.6667H3.16699C2.70676 15.6667 2.33366 15.2937 2.33366 14.8334V0.666748H0.666992Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58515 4.49949C6.05059 3.52953 6.50413 3.16675 6.99545 3.16675C7.33785 3.16675 7.57988 3.26816 7.78256 3.43786C8.00324 3.62262 8.21413 3.92105 8.40986 4.36336C8.80314 5.25206 9.03094 6.46248 9.28651 7.82047L9.30228 7.90426C9.55187 9.22999 9.83326 10.7016 10.38 11.8359C10.6591 12.415 11.031 12.9597 11.5511 13.361C12.0857 13.7735 12.7329 14.0001 13.4875 14.0001C15.0337 14.0001 15.8967 12.7707 16.4133 11.7324L16.7845 10.9863L15.2922 10.2439L14.9211 10.99C14.4352 11.9667 13.9866 12.3334 13.4875 12.3334C13.0889 12.3334 12.8025 12.2215 12.5693 12.0415C12.3217 11.8504 12.0918 11.5487 11.8814 11.1122C11.449 10.2152 11.2005 8.97851 10.9402 7.5959L10.9044 7.40576C10.6668 6.13986 10.4077 4.75934 9.93396 3.68889C9.68025 3.11557 9.33942 2.56764 8.85249 2.15996C8.34757 1.73721 7.72609 1.50008 6.99545 1.50008C5.45588 1.50008 4.5892 2.72257 4.08253 3.77845L3.72201 4.52976L5.22463 5.2508L5.58515 4.49949Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16699 7.33342H4.83366V9.00008H3.16699V7.33342Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3337 7.33342H14.0003V9.00008H12.3337V7.33342Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50033 7.33342H8.16699V9.00008H6.50033V7.33342Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.667 7.33342H17.3337V9.00008H15.667V7.33342Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverages);
export default __webpack_public_path__ + "static/media/averages.d4f565bd77f7bbe06053e412a7a75a49.svg";
export { ForwardRef as ReactComponent };